/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `bale_wires` - Bale wires
* `metal_straps` - Metal straps
* `not_banded` - Not banded
* `plastic_sheet` - Plastic sheet
* `plastic_wrap` - Plastic wrap
* `ropes` - Ropes
* `straps` - Straps
* `pp_bags` - PP Bags with plastic wrap
 */
export type StrappingEnum = typeof StrappingEnum[keyof typeof StrappingEnum];


export const StrappingEnum = {
  bale_wires: 'bale_wires',
  metal_straps: 'metal_straps',
  not_banded: 'not_banded',
  plastic_sheet: 'plastic_sheet',
  plastic_wrap: 'plastic_wrap',
  ropes: 'ropes',
  straps: 'straps',
  pp_bags: 'pp_bags',
} as const;
